export default __webpack_public_path__ + "static/media/consumptionGroupID.eca8fc1e.png";